import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=5b5424b2&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
import style0 from "./Services.vue?vue&type=style&index=0&id=5b5424b2&prod&scoped=true&lang=css"
import style1 from "./Services.vue?vue&type=style&index=1&id=5b5424b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5424b2",
  null
  
)

export default component.exports